/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ConversationSpeechMetricsOut {
  available: boolean;
  interruptions_available: boolean;
  unavailable_reason: string | null;
  interviewer_share: number | null;
  candidate_share: number | null;
}
